export function classNames(...classes: any[]) {
    return classes.filter(Boolean).join(' ')
}

export function classNamesOrEmpty(classNames: string | undefined) {
    return classNames ? classNames : "";
}